import React from "react";
import { useFormContext } from "react-hook-form";
import { cn } from "../../../utils/tw";

interface StyledInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label: string;
}

const StyledInput = React.forwardRef<HTMLInputElement, StyledInputProps>(
  ({ name, label, className, id, required, ...props }, ref) => {
    const { register, formState } = useFormContext();
    const {
      ref: rhfRef,
      ...rest
    } = register(name);
    const inputId = id || name || label.toLowerCase().replace(/\s+/g, "-");
    const error = (formState.errors as any)?.[name]?.message as string | undefined;

    return (
      <div className="space-y-1">
        <div className="relative">
          <input
            id={inputId}
            placeholder=" "
            className={cn(
              'peer w-full border border-border-default bg-bg-surface px-3 py-2 rounded-lg outline-none focus:border-ds-primary-500 focus:ring-1 focus:ring-ds-primary-500/30 placeholder-transparent min-h-[48px] text-text-primary',
              error && 'border-border-error focus:border-border-error focus:ring-ds-status-error-main/30',
              className
            )}
            required={required}
            {...rest}
            {...props}
            ref={e => {
              rhfRef(e);
              if (typeof ref === "function") ref(e);
              else if (ref) (ref as React.MutableRefObject<HTMLInputElement | null>).current = e;
            }}
          />
          <label
            htmlFor={inputId}
            className="absolute left-3 top-1 text-xs text-text-muted transition-all peer-focus:-top-2 peer-focus:text-xs peer-focus:text-ds-primary-600 peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-text-muted"
          >
            {label} {required && "*"}
          </label>
        </div>
        {error && <p className="text-ds-status-error-main text-xs">{error}</p>}
      </div>
    );
  }
);
StyledInput.displayName = "StyledInput";

export default StyledInput;
